export enum ENV {
  DEVELOPMENT = "development",
  PROD = "production",
  TEST = "test",
}

export type ApplicationConfig = {
  API_BASE_URL: string;
  PRODUCT_RECOMMENDATION_API_BASE_URL: string;
  INGESTION_SERVICE_API_BASE_URL: string;
  UNCHECK_SERVICE_API_BASE_URL: string;
  ENV: ENV;
  AUTH0: {
    AUDIENCE: string;
    CLIENT_ID: string;
    DOMAIN: string;
  };
  UNCHECK_ORGANISATION_ID: string;
};
